import { useAdminUsers } from '@/hooks/useAdminUsers'

interface TenantUsersCardProps {
  tenantId: string
}

export default function TenantUsersCard({ tenantId }: TenantUsersCardProps) {
  const { data, isLoading, error } = useAdminUsers({ tenant_id: tenantId })

  if (isLoading) {
    return (
      <div className="card p-6">
        <div className="text-gray-500">Loading users...</div>
      </div>
    )
  }

  if (error) {
    return (
      <div className="card p-6 bg-red-50 border-red-200">
        <p className="text-red-700">Failed to load users.</p>
      </div>
    )
  }

  const users = data?.users || []

  return (
    <div className="card">
      <div className="border-b border-gray-200 px-6 py-4">
        <h3 className="text-lg font-semibold text-gray-900">
          Users ({users.length})
        </h3>
      </div>

      {users.length === 0 ? (
        <div className="px-6 py-8 text-center text-gray-500">
          No users found for this tenant.
        </div>
      ) : (
        <div className="divide-y divide-gray-200">
          {users.map((user) => (
            <div key={user.id} className="px-6 py-4 hover:bg-gray-50">
              <div className="flex items-center justify-between">
                <div>
                  <div className="font-medium text-gray-900">{user.name}</div>
                  <div className="text-sm text-gray-500">{user.email}</div>
                </div>
                <div className="flex items-center gap-3">
                  <span
                    className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                      user.role === 'employee' || user.role === 'superuser'
                        ? 'bg-purple-100 text-purple-800'
                        : 'bg-blue-100 text-blue-800'
                    }`}
                  >
                    {user.role}
                  </span>
                  {user.mfa_enabled && (
                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                      MFA
                    </span>
                  )}
                  <span
                    className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                      user.is_active
                        ? 'bg-green-100 text-green-800'
                        : 'bg-gray-100 text-gray-800'
                    }`}
                  >
                    {user.is_active ? 'Active' : 'Inactive'}
                  </span>
                </div>
              </div>
              {user.last_login && (
                <div className="mt-2 text-xs text-gray-500">
                  Last login: {new Date(user.last_login).toLocaleString()}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
